import { render, staticRenderFns } from "./RetentionsList.vue?vue&type=template&id=7809dc62"
import script from "./RetentionsList.vue?vue&type=script&lang=ts"
export * from "./RetentionsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports